import deburr from 'lodash/deburr'

export function buildMemberNameProps(memberData) {
  const displayName =
    memberData.nickName || memberData.socialName || memberData.firstName
  const fullName = [memberData.firstName, memberData.lastName]
    .filter(Boolean)
    .join(' ')
  const sanitizedFullName = encodeURI(deburr(fullName).toLowerCase())
  return {
    fullName,
    displayName,
    sanitizedFullName
  }
}
